// export const baseUrl = "http://localhost:8080";
export const localUrl = "http://localhost:8080";
//export const baseUrl = "https://sms-backend-fi7d.onrender.com/";
export const baseUrl = process.env.REACT_APP_API_URL || localUrl;
